var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ns-progress"},[_c('div',{staticClass:"ns-progress-bar",style:({ background: _vm.color, width: _vm.percent })})])}
var staticRenderFns = []

export { render, staticRenderFns }